import { Icone } from './Icone'

// « Traiter avec Claude » (décisions du 11/10/2026 pour récupérer une pièce, et du 13/10/2026 pour
// toute tâche ouverte) : Claude desktop en Cowork (lien claude://) avec le prompt prêt, claude.ai
// sur un téléphone, où claude:// n'ouvre rien. Le prompt est aussi copié, à coller ailleurs si
// l'appli ne s'ouvre pas.

/** Cowork de Claude desktop, prompt prérempli (support.claude.com, « Open Claude desktop with a link »). */
export const lienCowork = (prompt: string) => `claude://cowork/new?q=${encodeURIComponent(prompt)}`
/** Sans l'appli de bureau (téléphone) : claude.ai, sans Chrome. */
export const lienClaudeAi = (prompt: string) =>
  `https://claude.ai/new?q=${encodeURIComponent(prompt)}`

/** Écran tactile (téléphone, tablette) : claude.ai d'abord. */
function tactile(): boolean {
  try {
    return window.matchMedia('(pointer: coarse)').matches
  } catch {
    return false
  }
}

const copier = (prompt: string) =>
  void navigator.clipboard?.writeText(prompt).catch(() => undefined)

/**
 * `geant` : le gros bouton d'une tâche « récupérer la pièce » ; `normal` : en tête de fiche ;
 * `icone` : sur une ligne de liste.
 */
export function BoutonClaude({
  prompt,
  taille = 'normal',
  aide = taille !== 'icone',
}: {
  prompt: string
  taille?: 'geant' | 'normal' | 'icone'
  aide?: boolean
}) {
  const surTelephone = tactile()
  const principal = surTelephone ? lienClaudeAi(prompt) : lienCowork(prompt)
  const cible = surTelephone ? { target: '_blank', rel: 'noreferrer noopener' } : {}
  if (taille === 'icone')
    return (
      <a
        className="bouton-icone cadre"
        href={principal}
        {...cible}
        title="Traiter avec Claude"
        aria-label="Traiter avec Claude"
        onClick={() => copier(prompt)}
      >
        <Icone nom="auto_awesome" taille={18} />
      </a>
    )
  return (
    <div className="ouvrir-claude">
      <a
        className={taille === 'geant' ? 'bouton bouton-geant' : 'bouton'}
        href={principal}
        {...cible}
        onClick={() => copier(prompt)}
      >
        <Icone nom="auto_awesome" taille={taille === 'geant' ? 22 : 18} />
        Traiter avec Claude
      </a>
      {aide && (
        <p className="discret">
          {surTelephone ? (
            'claude.ai, avec le prompt prêt (aussi copié).'
          ) : (
            <>
              Claude desktop (Cowork), qui passe par Claude in Chrome pour les sites où vous êtes
              connecté ; le prompt est aussi copié. Sans l’appli :{' '}
              <a
                href={lienClaudeAi(prompt)}
                target="_blank"
                rel="noreferrer noopener"
                onClick={() => copier(prompt)}
              >
                claude.ai
              </a>
              .
            </>
          )}
        </p>
      )}
    </div>
  )
}
